<template>
    <div class="main-wrapper">
        <header class="section-header">     
            <div class="header_logo">
                <router-link :to="{ name: 'Home' }">
                    <img src="@/assets/images/company/Boolland_logo_white_full.png" alt="Boolland Logo">
                </router-link>
            </div>
            <nav class="font-monospace">
                <!-- <router-link :to="{ name: 'Home' }">Home</router-link>
                <router-link :to="{ name: 'Project' }">Project</router-link>
                <router-link :to="{ name: 'Insight' }">Insight</router-link>
                <router-link :to="{ name: 'Contact' }">Contact</router-link>
                <router-link :to="{ name: 'Style' }">Style</router-link>
                <router-link :to="{ name: 'Service' }">Service</router-link>
                <router-link :to="{ name: 'Collaboration' }">Collaboration</router-link> -->
            </nav>        
            <div class="header_sub_nav text-end">
                <!-- <button>Contact Us</button> -->
            </div>
            <div class="section-header-background"></div>      
        </header>  
        <div class="main_page">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {      
    }
}
</script>
<style lang="scss">    
    @import './src/assets/styles/boolland.scss';
    
    .main-wrapper{
        position: relative;  
        max-height: 100vh;  
        max-height: 100dvh;          
    }
    
    .section-header{
        position: fixed;
        top: 0%;
        left: 0%;
        width: 100%;
        z-index: 10;
        display: flex;
        padding: $gutter;
        &-background{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 8rem;
            z-index: -1;
            background: linear-gradient(180deg, #0c0c0c 5%,rgba(12,12,12,.9) 40%,transparent 100%);
        }
        .header_logo{
            flex: 1 0 0%;
            img{    
                height: 1.5rem;
            }
        }                    

        nav{
            flex: 1 0 0%;
            display: flex;
            gap: 15px;
            // padding: 1rem 2rem;
            font-size: 0.8rem;
            justify-content: center;
            align-items: center;
            a{
                color: var(--body-color) !important;    
                text-decoration: none;            
            }
        }
        .header_sub_nav{
            flex: 1 0 0%;
        }
        // .header_logo svg{                        
        //     $logo_size: 2.5rem;
        //     width: $logo_size;
        //     height: $logo_size;
        // }
    }
    
</style>


// WEBPACK FOOTER //
// src/views/portfolio/Layout.vue